import { render, staticRenderFns } from "./lists.vue?vue&type=template&id=5d8f711a&scoped=true"
import script from "./lists.vue?vue&type=script&lang=js"
export * from "./lists.vue?vue&type=script&lang=js"
import style0 from "./lists.vue?vue&type=style&index=0&id=5d8f711a&prod&scoped=true&lang=scss"
import style1 from "./lists.vue?vue&type=style&index=1&id=5d8f711a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8f711a",
  null
  
)

export default component.exports